export class Cache {
  private cache: { [key: string]: unknown };

  public persist = true;

  constructor() {
    this.cache = {};
  }

  private canPersist(): boolean {
    return this.persist && typeof sessionStorage !== 'undefined';
  }

  public setValue(key: string, value: unknown): void {
    this.cache[key] = value;
    if (this.canPersist()) {
      sessionStorage.setItem('cache', JSON.stringify(this.cache));
    }
  }

  public getValue<T = unknown>(key: string): T {
    if (!this.cache[key]) {
      const storedCache = this.canPersist() ? sessionStorage.getItem('cache') : null;
      if (storedCache) {
        this.cache = JSON.parse(storedCache);
      }
    }
    return this.cache[key] as T;
  }
}
